module.exports = __webpack_public_path__ + "static/media/default_small.bc946a31.png";